import { Button, Center, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconAlertTriangle, IconRefresh } from '@tabler/icons-react';
import { apiErrorMessage } from '../lib/errors';
import { t } from '../lib/strings';

/** Consistent load-failure state: message (via apiErrorMessage) + Retry. */
export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <Center py={48} px="md">
      <Stack align="center" gap="xs" maw={420}>
        <ThemeIcon variant="light" color="red" size={52} radius="xl">
          <IconAlertTriangle size={26} />
        </ThemeIcon>
        <Text fw={600}>{t.errors.title}</Text>
        <Text c="dimmed" size="sm" ta="center">{apiErrorMessage(error)}</Text>
        {onRetry && (
          <Button variant="light" size="sm" mt="xs" onClick={onRetry} leftSection={<IconRefresh size={16} />}>
            {t.errors.retry}
          </Button>
        )}
      </Stack>
    </Center>
  );
}
